"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const mitt_1 = tslib_1.__importDefault(require("mitt"));
const eventBus = (0, mitt_1.default)();
/**
 * EventBus was a Vue pattern that is removed in Vue 3 and is discouraged
 * This is using `mitt` at the moment to prepare for Vue 3 but will be removed to not encourage devs to use EventBus
 * https://v3-migration.vuejs.org/breaking-changes/events-api.html#event-bus
 *
 * Apps should aim to remove EventBus and replace it with one of the alternative patterns.
 */
exports.default = Object.assign(Object.assign({}, eventBus), { 
    /**
     * @deprecated Event bus will be removed in next breaking version - For suggestions on what to use instead, see https://v3-migration.vuejs.org/breaking-changes/events-api.html#event-bus
     */
    $emit(type, ...args) {
        this.emit(type, ...args);
    },
    /**
     * @deprecated Event bus will be removed in next breaking version - For suggestions on what to use instead, see https://v3-migration.vuejs.org/breaking-changes/events-api.html#event-bus
     */
    $on(type, callback) {
        this.on(type, callback);
    },
    /**
     * @deprecated Event bus will be removed in next breaking version - For suggestions on what to use instead, see https://v3-migration.vuejs.org/breaking-changes/events-api.html#event-bus
     */
    off(type, callback) {
        if (callback) {
            eventBus.off(type, callback);
            return;
        }
        // Allow to remove event without knowing the handler
        eventBus.all.delete(type);
    },
    /**
     * @deprecated Event bus will be removed in next breaking version - For suggestions on what to use instead, see https://v3-migration.vuejs.org/breaking-changes/events-api.html#event-bus
     */
    $off(type, callback) {
        this.off(type, callback);
    } });
//# sourceMappingURL=event-bus.js.map